<template>
  <div class="application-page">
    <div class="application-content">
      <van-nav-bar
        :title="$t('applications.designer.title')"
        left-arrow
        @click-left="$router.back()"
      />

      <div class="form-card designer">
        <div class="form-header">
          <div class="form-icon">
<!--            <van-icon name="brush" />-->
            <img src="../../assets/cooperation/brush.png" />
          </div>
          <div>
            <h2 class="form-title">
              {{ $t('applications.designer.title') }}
            </h2>
            <p class="form-subtitle">
              {{ $t('applications.designer.subtitle') }}
            </p>
          </div>
        </div>

        <van-form
          class="application-form"
          @submit="handleSubmit"
        >
          <van-cell-group>
            <van-field
              v-model="formData.designerName"
              :label="$t('applications.designer.designerName')"
              :placeholder="$t('applications.designer.designerNamePlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <van-field
              v-model="formData.brandName"
              :label="$t('applications.designer.brandName')"
              :placeholder="$t('applications.designer.brandNamePlaceholder')"
            />

            <van-field
              v-model="formData.designField"
              :label="$t('applications.designer.designField')"
              :placeholder="$t('applications.designer.designFieldPlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <van-field
              v-model="formData.experienceYears"
              type="number"
              :label="$t('applications.designer.experienceYears')"
              :placeholder="$t('applications.designer.experienceYearsPlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <van-field
              v-model="formData.educationBackground"
              :label="$t('applications.designer.educationBackground')"
              type="textarea"
              autosize
              :placeholder="$t('applications.designer.educationBackgroundPlaceholder')"
              rows="2"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <van-field
              v-model="formData.workExperience"
              :label="$t('applications.designer.workExperience')"
              type="textarea"
              autosize
              :placeholder="$t('applications.designer.workExperiencePlaceholder')"
              rows="2"
            />

            <van-field
              v-model="formData.representativeWorks"
              :label="$t('applications.designer.representativeWorks')"
              type="textarea"
              autosize
              :placeholder="$t('applications.designer.representativeWorksPlaceholder')"
              rows="2"
            />

            <van-field
              v-model="formData.awards"
              :label="$t('applications.designer.awards')"
              type="textarea"
              autosize
              :placeholder="$t('applications.designer.awardsPlaceholder')"
              rows="2"
            />

            <van-field
              v-model="formData.personalIntroduction"
              :label="$t('applications.designer.personalIntroduction')"
              type="textarea"
              autosize
              :placeholder="$t('applications.designer.personalIntroductionPlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
              rows="3"
            />
          </van-cell-group>

          <div class="section-title">
            {{ $t('applications.contactInfo') }}
          </div>
          <van-cell-group>
            <van-field
              v-model="formData.contactPhone"
              type="tel"
              :label="$t('applications.contactPhone')"
              :placeholder="$t('applications.contactPhonePlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <van-field
              v-model="formData.contactEmail"
              type="email"
              :label="$t('applications.contactEmail')"
              :placeholder="$t('applications.contactEmailPlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />
          </van-cell-group>

          <div class="agreement-section">
            <van-checkbox
              v-model="agreeTerms"
              shape="square"
              required
            >
              {{ $t('applications.agreeTerms') }}
            </van-checkbox>
          </div>

          <div class="submit-section">
            <van-button
              round
              block
              type="primary"
              native-type="submit"
              :loading="submitting"
              class="submit-btn"
            >
              {{ $t('common.submit') }}
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <van-overlay
      :show="submitting"
      class="submitting-overlay"
    >
      <div class="overlay-content">
        <van-loading size="24px" vertical>
          {{ $t('common.submitting') }}
        </van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { showToast, showSuccessToast } from 'vant'
import { designerCooperationApply } from '@/api/cooperation'

export default {
  name: 'DesignerApplication',
  setup () {
    const { t } = useI18n()
    const router = useRouter()

    // const formData = reactive({
    //   designerName: '张张',
    //   brandName: 'Super',
    //   designField: '服装设计',
    //   experienceYears: '10',
    //   educationBackground: '皇家设计院深造2年',
    //   workExperience: '',
    //   representativeWorks: '',
    //   awards: '',
    //   contactPhone: '张',
    //   contactEmail: '123@123.dom',
    //   personalIntroduction: '独立风格'
    // })
    const formData = reactive({
      designerName: '',
      brandName: '',
      designField: '',
      experienceYears: '',
      educationBackground: '',
      workExperience: '',
      representativeWorks: '',
      awards: '',
      contactPhone: '',
      contactEmail: '',
      personalIntroduction: ''
    })

    const submitting = ref(false)
    const agreeTerms = ref(false)

    const handleSubmit = async () => {
      if (!agreeTerms.value) {
        showToast(t('applications.agreeTermsRequired'))
        return
      }

      submitting.value = true

      designerCooperationApply(formData).then(res => {
        submitting.value = false
        showSuccessToast(t('applications.submitSuccess'))
        agreeTerms.value = false
        setTimeout(() => {
          router.back()
        }, 1500)
      }).catch(error => {
        submitting.value = false
        showToast(t('common.submitFailed') + error.msg)
      })
    }

    return {
      formData,
      submitting,
      agreeTerms,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.application-page {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.application-content {
  padding: 16px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  //@media (min-width: 1200px) {
    //max-width: 600px;
  //  margin: 0 auto;
  //  padding: 24px;
  //}
}

.form-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-top: 5px solid;
  margin-top: 16px;

  &.designer {
    border-top-color: #8b5cf6;
  }

  .form-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .form-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: white;
      margin-right: 15px;
      background: #8b5cf6;
      img{
        width: 30px;
        height: 30px;
      }
    }

    .form-title {
      font-size: 20px;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 4px;
    }

    .form-subtitle {
      font-size: 14px;
      color: #64748b;
      margin: 0;
    }
  }
}

.application-form {
  .form-row {
    display: flex;
    gap: 12px;

    :deep(.van-field) {
      flex: 1;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin: 24px 0 16px;
    padding-left: 16px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 16px;
      background: #3b82f6;
      border-radius: 2px;
    }
  }

  :deep(.van-cell-group) {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
  }

  :deep(.van-field) {
    padding: 12px 16px;

    .van-field__label {
      font-weight: 500;
      color: #374151;
    }
  }
}

.agreement-section {
  margin: 24px 0;
  padding: 0 16px;

  :deep(.van-checkbox) {
    align-items: flex-start;

    .van-checkbox__label {
      font-size: 14px;
      color: #64748b;
      line-height: 1.4;
    }
  }
}

.submit-section {
  margin-top: 32px;

  .submit-btn {
    height: 44px;
    font-size: 16px;
    font-weight: 500;
  }
}

.submitting-overlay {
  display: flex;
  align-items: center;
  justify-content: center;

  .overlay-content {
    text-align: center;
    color: white;
  }
}

/* 1080×1920 设备适配 */
@media (min-width: 1080px) and (min-height: 1920px) {
  .application-content {
    padding: 32px;
  }

  .form-card {
    padding: 32px;
    margin-top: 24px;

    .form-header {
      margin-bottom: 32px;

      .form-icon {
        width: 80px;
        height: 80px;
        font-size: 32px;
      }

      .form-title {
        font-size: 24px;
      }

      .form-subtitle {
        font-size: 16px;
      }
    }
  }

  .application-form {
    :deep(.van-field) {
      padding: 16px 20px;

      .van-field__label {
        font-size: 18px;
      }

      .van-field__control {
        font-size: 18px;
      }
    }
  }

  .submit-section .submit-btn {
    height: 56px;
    font-size: 18px;
  }
}

/* PC端优化 */
@media (min-width: 1200px) {
  .application-page {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
  }

  .application-content {
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    width: 100%;
    //max-width: 600px;
    margin: 40px auto;
  }

  .form-card {
    box-shadow: none;
    padding: 32px;
    margin-top: 0;
  }
}

/* 移动端适配 */
@media (max-width: 767px) {
  .application-content {
    padding: 12px;
  }

  .form-card {
    padding: 16px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }
}
</style>
